// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"4981a1df","99":"617b2a4c","480":"0396be3f","573":"2aaa3736","649":"ddd46abb","911":"134dfb31"}[chunkId] + ".chunk.js";
};